<template>
  <div id="app" :style="{ fontFamily: selectedFont }">
    <el-container>
      <el-header v-if="show" class="app-topbar">
        <AppHeader ref="header" />
      </el-header>
      <el-container v-bind:class="{ 'app-body': show }">
        <AppMenu v-if="show" @redirect="redirect" @chat="chat" @focus.native="focus" @blur.native="hover" />
        <el-container>
          <el-main width="80%" v-bind:class="{ border0: $route && $route.name === 'login', 'side-menu': show }">
            <fade-transition origin="center" mode="out-in" :duration="250">
              <router-view />
            </fade-transition>
          </el-main>
        </el-container>
      </el-container>
    </el-container>
    <template v-if="show">
      <ImpersonationBanner v-if="impersonating" />
      <ForcePasswordChange v-else />
    </template>
  </div>

</template>
<script>
import AppHeader from "@/layout/AppHeader.vue";
import { FadeTransition } from "vue2-transitions";
import store from "./store";
import { i18n } from "@/plugin/i18n";
import AppMenu from "./layout/AppMenu.vue";
import ForcePasswordChange from "./layout/components/ForcePasswordChange.vue";
import ImpersonationBanner from "./layout/components/ImpersonationBanner.vue";
import { TokenService } from "./services/auth/storage.services";
import config from "@/sites/config.json"

export default {
  components: {
    FadeTransition,
    AppHeader,
    AppMenu,
    ForcePasswordChange,
    ImpersonationBanner
  },
  methods: {
    hover() {
      console.log('hover')
    },
    focus() {
      console.log('focus')
    },
    redirect(page) {

    },
    chat() {
      this.$refs.header.chat();
    },
    setup() {
      const favicon = document.querySelector('link[rel="icon"]');
      if (favicon) {
        favicon.href = this.site.icon;
      }
      this.selectedFont = this.site["Font-family"];
      document.title = this.site.pages.home.title;
    },
  },
  computed: {
    show() {
      const vm = this;
      return vm.menu;
    },
  },
  data() {
    return {
      menu: false,
      impersonating: TokenService.isImpersonating(),
      collapse: true,
      site: config["default"],
      selectedFont: "var(--me-font-family)", // fonte unificada — ver _tokens.scss
    };
  },
  mounted() {
    const vm = this;
    vm.menu = store.state.auth.accessToken !== null;
    vm.$bus.$on("logout", () => {
      vm.menu = store.state.auth.accessToken !== null;
    });
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    const site = parts.length === 4 ? parts[0] : 'default';
    vm.site = config[site] || config['default'];
    vm.setup();
    vm.$options.loading = {
      lock: true,
      text: i18n.tc("carregando"),
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    };
    vm.$bus.$on("logged", () => {
      vm.menu = store.state.auth.accessToken !== null;
    });
  },
};
</script>
<style scoped>
@font-face {
  font-family: "Avenit";
  src: local("Avenit"), url(./assets/fonts/AEH.ttf) format("truetype");
  font-weight: normal;
  font-style: normal;
}

@import "./assets/style.css";

.border0 {
  padding: 0px !important;
  overflow: hidden;
}
.page {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  min-height: 100vh;
}

/* Header congelado no topo; o conteúdo (.app-body) compensa a altura. */
.app-topbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1600;
  height: 60px !important;
  padding: 0 8px;
  background: #fff;
  border-bottom: 1px solid var(--me-border-lighter);
}

.app-body {
  margin-top: 60px;
}

/* Largura da sidebar recolhida (63px) + respiro */
.side-menu {
  margin: 0px 0px 0px 75px !important;
}

@media only screen and (max-width: 767px) {
  /* No mobile a sidebar fica off-canvas — conteúdo ocupa 100% */
  .side-menu {
    margin: 0px !important;
  }
}


</style>


